import React, { useState, useEffect } from 'react';
import '../styles/components/OngoingProjects.scss';

const OngoingProjects = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroImages = [
    '/images/student-mentorship.jpg',
    '/images/services-hero.jpg',
    '/images/city.jpg',
    '/images/projects-bg.jpg',
    '/images/enterprise.jpg'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Updated projects data - REMOVE HTML TAGS from JSON
  const ongoingProjects = [
    {
      id: 1,
      title: "Fiscal Space Analysis and Financing Strategy for the Home-Grown School Meals Program in Zambia",
      client: "Education Development Centre & World Food Programme",
      location: "Zambia",
      description: "Under the auspices of the Education Development Center (EDC), and in partnership with the World Food Programme (WFP), Dythel Consulting has been contracted to support the Ministry of Education in developing a comprehensive Financing Strategy for the School Feeding Programme in Zambia. As the Lead Financing Strategy and Fiscal Space Consultant, Dythel Consulting is responsible for conducting an in-depth fiscal space analysis and formulating a sustainable financing strategy for the Home-Grown School Meals (HGSM) Programme.",
      scopeOfWork: [
        "Desk review",
        "Fiscal space analysis",
        "10 provinces and 116 districts are being surveyed",
        "Mixed-method approach including qualitative and quantitative methods",
        "Data collection using survey questionnaire, document review, and key informant interviews"
      ],
      status: "In Progress",
      timeline: "4 Months",
      duration: "December 2025 to April 2026",
      category: "Education & Development Finance"
    },
    {
      id: 2,
      title: "Research on the Implementation of the 2023 Curriculum in Zambia",
      client: "Zambia National Education Coalition (ZANEC)",
      location: "10 Provinces, Zambia",
      description: "Dythel Consulting is undertaking an evaluation of the implementation of the 2023 Competency-Based Curriculum (CBC), launched by the Ministry of Education to reform the Zambian education system and align it with global trends. The objective of the study is to assess the extent to which the curriculum has been implemented across various education levels in Zambia and to identify the key challenges and barriers affecting its effective implementation.",
      scopeOfWork: [
        "10 provinces are being surveyed",
        "Mixed-method approach including qualitative and quantitative methods",
        "Data collection using survey questionnaire, document review, and key informant interviews"
      ],
      status: "In Progress",
      timeline: "2 Months",
      duration: "November to December 2025",
      category: "Education Research"
    },
    {
      id: 3,
      title: "Political Economy Analysis of the Primary Education Sector in Zambia",
      client: "TaRL Africa",
      location: "Zambia",
      description: " Mr.Sydney Mupeta Our Managing Partner - Research & Consultancy is collaborating with researchers at the University of Zambia to conduct a political economy analysis of the primary education sector in Zambia. The study seeks to generate an in-depth understanding of what and how political, institutional, and governance factors shape education delivery and learning outcomes. The analysis seeks to go beyond a technical review of systems and instead interrogate the incentive structures, power relations, and formal and informal institutional arrangements that influence decision-making within the primary education sub-sector.",
      scopeOfWork: [
        "10 provinces are being surveyed",
        "Mixed-method approach including qualitative and quantitative methods",
        "Data collection using survey questionnaire, data collection sheet, document review, and key informant interviews"
      ],
      status: "In Progress",
      timeline: "2 Months",
      duration: "November to December 2025",
      category: "Political Economy Analysis",
    //  boldText: "Our Managing Partner - Research & Consultancy"
    },
    {
      id: 4,
      title: "Youth Engagement Expert/Consultant on the Status of Civil Society in Zambia Project",
      client: "Southern African Institute for Policy and Research (SAIPAR)",
      location: "Lusaka, Zambia",
      description: " Mr.Sydney Mupeta Our Managing Partner - Research & Consultancy is a Youth Engagement Expert/Consultant on the status of civil society in Zambia project, falling under the broader project titled, 'Building Stronger Political Partnerships to Address National and Regional Challenges' commissioned by the Irish Embassy in Zambia in partnership with SAIPAR. The project focuses on assessing the consequences of the decline of funding for civil society organisations, specifically assessing the current financial status of CSOs in Zambia, impact of declined funding on CSOs, adaptation to declining funding, sustainability models and long-term organisational strategies, among others.",
      scopeOfWork: [
        "Lusaka province is being surveyed, targeting 40 Civil Society organisations in the governance sector, including donors",
        "Qualitative research methods",
        "Data collection using interviews and document reviews"
      ],
      status: "In Progress",
      timeline: "5 Months",
      duration: "October 2025 to February 2026",
      category: "Civil Society Research",
      boldText: "Our Managing Partner - Research & Consultancy"
    }
  ];

  // Function to render description with bold text
const renderDescription = (project) => {
  if ((project.id === 3) && project.boldText) {
    const parts = project.description.split(project.boldText);
    return (
      <>
        {parts[0]}
        <strong className="bold-emphasis">{project.boldText}</strong>
        {parts[1]}
      </>
    );
  }
  return project.description;
};

  return (
    <div className="ongoing-projects-page">
      {/* Slideshow Hero Section - keep as is */}
      <section className="projects-hero-slideshow">
        <div className="slideshow-container">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${image})` }}
            >
              <div className="slide-content">
                <div className="container">
                  <h1>Ongoing Projects</h1>
                  <p>Explore our current initiatives and ongoing work that's shaping the future of our clients and driving innovation across industries</p>
                  <div className="hero-actions">
                    <a href="#active-projects" className="btn btn-primary">
                      View Active Projects
                    </a>
                    <a href="#coming-soon" className="btn btn-secondary">
                      Upcoming Initiatives
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="slide-nav prev" onClick={prevSlide}>
          <i className="fas fa-chevron-left"></i>
        </button>
        <button className="slide-nav next" onClick={nextSlide}>
          <i className="fas fa-chevron-right"></i>
        </button>

        <div className="slide-indicators">
          {heroImages.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </section>

      {/* Active Projects Section - UPDATED */}
      <section id="active-projects" className="projects-content">
        <div className="container">
          <div className="projects-header">
            <h2>Active Engagements</h2>
            <p>We're currently working on strategic projects across various sectors</p>
          </div>
          
          <div className="projects-grid">
            {ongoingProjects.map(project => (
              <div key={project.id} className="project-card">
                <div className="project-header">
                  <h3>{project.title}</h3>
                  <span className={`project-status ${project.status.toLowerCase().replace(' ', '-')}`}>
                    {project.status}
                  </span>
                </div>
                
                <div className="project-client">
                  <i className="fas fa-building"></i>
                  {project.client}
                </div>
                
                <div className="project-location">
                  <i className="fas fa-map-marker-alt"></i>
                  {project.location}
                </div>

                {/* UPDATED: Use the render function */}
                <p className="project-description">
                  {renderDescription(project)}
                </p>

                <div className="project-scope">
                  <h4>Scope of Work:</h4>
                  <ul>
                    {project.scopeOfWork.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="project-meta">
                  <div className="meta-item">
                    <i className="fas fa-clock"></i>
                    <span>Duration: {project.timeline}</span>
                  </div>
                  <div className="meta-item">
                    <i className="fas fa-calendar"></i>
                    <span>{project.duration}</span>
                  </div>
                  <div className="meta-item">
                    <i className="fas fa-tag"></i>
                    <span>{project.category}</span>
                  </div>
                </div>

                <div className="project-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: '65%' }}></div>
                  </div>
                  <span className="progress-text">65% Complete</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default OngoingProjects;